module.exports = __webpack_public_path__ + "static/media/29BDOS11.20f4ed73.jpg";